module.exports = __webpack_public_path__ + "img/a00586b.jpg";